import { Component, OnInit } from "@angular/core";
import { SolarApplicationsService } from "../../../services/service-provider.service"; // Import the service
import { ActivatedRoute, Router } from "@angular/router";
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

@Component({
  selector: "app-applications",
  templateUrl: "./applications.component.html",
  styleUrls: ["./applications.component.scss"],
})
export class ApplicationsComponent implements OnInit {
  applications: any[] = [];
  applicationsStates: any[] = [];
  applicationStateId = 0;

  limit = 8;
  offset = 0;
  totalApplications = 0;
  currentPage = 1; 

  searchTerm = '';
  searchSubject: Subject<string> = new Subject();

  constructor(
    private solarApplicationsService: SolarApplicationsService,
    private router: Router,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      this.applicationStateId = params['applicationStateId'];
      this.fetchApplications(this.applicationStateId);
      this.fetchApplicationsStates(); 

      this.searchSubject.pipe(
        debounceTime(300),
        distinctUntilChanged() 
      ).subscribe((searchTerm) => {
        this.offset = 0;  
        this.currentPage = 1;
        this.fetchApplications(this.applicationStateId, searchTerm);
      });
    });
  }
  onTabClick(applicationStateId: number) {
    this.applicationStateId = applicationStateId;
    this.offset = 0;  
    this.fetchApplications(applicationStateId, this.searchTerm);
  }


  fetchApplications(applicationStateId: number, filter: string = ''): void {
    this.solarApplicationsService.getApplicationsReceived(this.limit, this.offset, applicationStateId, filter).subscribe({
      next: (data) => {
        this.applications = data.items;
        this.totalApplications = data.total_items;  
        console.log(data);
      },
      error: (error) => {
        console.error('Error fetching applications:', error); 
      }
    });
  }

  goToAction(applicationId: string) {
    this.router.navigate([`/action/${applicationId}`]);
  }

  fetchApplicationsStates(): void {
    this.solarApplicationsService.getApplicationsStates().subscribe({
      next: (data) => {
        this.applicationsStates = data.items;
        console.log(this.applicationsStates);
      },
      error: (error) => {
        console.error("Error fetching applications:", error);
      },
    });
  }

  onPageChanged(page: number): void {
    this.currentPage = page;
    this.offset = (page - 1) * this.limit;
    this.fetchApplications(this.applicationStateId, this.searchTerm);
  }

  onSearchChange() {
    this.searchSubject.next(this.searchTerm);
  }
}
